
import { API_ENDPOINTS } from './api-endpoints';
import { crudFactory } from './curd-factory';
import { HttpClientFront } from './http-client-front';
{/*
export const productClient = {
  ...crudFactory(API_ENDPOINTS.PRODUCTS),
  get({ slug, language }: GetParams) {
    return HttpClient.get(`${API_ENDPOINTS.PRODUCTS}/${slug}`, {
      language,
      with: 'type;shop;categories;tags;variations.attribute.values;variation_options;author;manufacturer;digital_file',
    });
  },
  paginated: ({
    type,
    name,
    categories,
    shop_id,
    ...params
  }) => {
    return HttpClient.get(API_ENDPOINTS.PRODUCTS, {
      searchJoin: 'and',
      with: 'shop;type',
      ...params,
      search: name
    });
  },
  popular({ shop_id, ...params }: Partial) {
    return HttpClient.get(API_ENDPOINTS.POPULAR_PRODUCTS, {
      searchJoin: 'and',
      with: 'type;shop',
      ...params,
      search: HttpClient.formatSearchParams({ shop_id }),
    });
  },
};
*/}

export const getCompanyPostDetails = {
  
  ...crudFactory(API_ENDPOINTS.FORUM),
  get:({ 
    company_id,
    ...params 
  }) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.FORUM}/`+company_id, {
      ...params,
      
    });
  },
  all:(params ) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.FORUM}`, params);
  },
};

export const getAllForumDetails = {
  
  ...crudFactory(API_ENDPOINTS.FORUM),
  get:({     
    ...params 
  }) => {    
    return HttpClientFront.get(`/all_forum`, {
      ...params,
      
    });
  },
  
};

export const postClient = {
  store_post: (variables) => {
    return HttpClientFront.post('/store_post', variables);
  },
  like_post: (postId) => {
    return HttpClientFront.post('/post_like', {
      postId: postId
    });
  },
  store_repost: (postId) => {
    return HttpClientFront.post('/repost', {
      postId: postId
    });
  },
  reply_post: (variables) => {
    //console.log('postid===>', variables)
    return HttpClientFront.post('/reply_post', variables);
  },
}

export const fetchReplies = async ({ postId, page }) => {
  const res = await HttpClientFront.get(`/post/${postId}/replies`, {
    params: {
      page: page,
      limit: 5
    }
  });

  return res.data;   // MUST be full response { data, hasMore, page, total }
};

export const reportPost = (data) => {
  return HttpClientFront.post("/post/report", data);
};

export const getForumKingUsers = {
  
  ...crudFactory(API_ENDPOINTS.FORUM),
  get:({     
    ...params 
  }) => {    
    return HttpClientFront.get(`/active_user_forum`, {
      ...params,
      
    });
  },
  
};

export const getForumPopularStock = {
  
  ...crudFactory(API_ENDPOINTS.FORUM),
  get:({     
    ...params 
  }) => {    
    return HttpClientFront.get(`/popular_in_forum`, {
      ...params,
      
    });
  },
  
};